/** @fileoverview Green tick that grows in on an action button after its run worked, then shrinks away. */

import { Check } from 'lucide-react';

/**
 * Always rendered, so it can animate both ways: it opens its space and fades in when shown, and
 * fades out and closes its space again when hidden. The negative margin cancels the button's gap
 * while hidden, so the label does not move.
 * @param props whether the tick shows
 */
const DoneTick = ({ isShown }: { isShown: boolean }) => (
  <span
    aria-hidden={!isShown}
    className={`inline-flex overflow-hidden transition-all duration-300 ease-out ${
      isShown ? 'mr-0 max-w-3.5 scale-100 opacity-100' : '-mr-1 max-w-0 scale-50 opacity-0'
    }`}
  >
    <Check className="shrink-0 text-success" strokeWidth={3} aria-label="Done" />
  </span>
);

export default DoneTick;
